import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        // =============================================================
        // Step 0: Landing page
        // =============================================================
        case 'godt-at-vide':
            nextPage = 'samtykke';
            break;
        case 'samtykke':
            nextPage = 'hvem';
            break;
        // =============================================================
        // Step 1: About the person
        // =============================================================
        case 'hvem':
            nextPage = 'dato';

            if (getValueOrDefault(formConfig, formValues, 'claimant').value === 'OTHER_CLAIMANT') {
                nextPage = 'om-anden-person';
            }

            break;
        case 'om-anden-person':
            nextPage = 'dato';
            break;

        // =============================================================
        // Step 2: About the damage
        // =============================================================
        case 'dato':
            nextPage = 'hvor-skete-skaden';
            break;
        case 'hvor-skete-skaden':
            nextPage = 'undersoegelse-af-taender';

            const lossLocation = getValueOrDefault(formConfig, formValues, 'lossLocation').value;

            if (lossLocation === 'WORK') {
                nextPage = 'om-ansaettelse';
            } else if (lossLocation === 'OTHER') {
                nextPage = 'om-stedet';
            }

            break;
        case 'om-ansaettelse':
            nextPage = 'undersoegelse-af-taender';
            break;
        case 'om-stedet':
            nextPage = 'undersoegelse-af-taender';
            break;
        case 'undersoegelse-af-taender':
            const examinedByDentist = getValueOrDefault(formConfig, formValues, 'dentist').value;

            if (examinedByDentist === 'yes') {
                return 'oplysninger-om-tandlaege';
            } else {
                return 'vaelg-hvilke-taender';
            }

        case 'oplysninger-om-tandlaege':
            nextPage = 'vaelg-hvilke-taender';
            break;
        case 'vaelg-hvilke-taender':
            nextPage = 'hvordan-skete-skaden';
            break;
        case 'hvordan-skete-skaden':
            const claimActivity = getValueOrDefault(formConfig, formValues, 'claimActivity').value;
            nextPage = getNextPageBasedOnClaimActivity(claimActivity);
            break;

        // how did it happen: sport
        case 'oplysninger-om-skaden':
            nextPage = 'paavirkning';

            if (getValueOrDefault(formConfig, formValues, 'claimActivity').value === 'TRAFFIC') {
                nextPage = 'politi';
            }

            break;

        // how did it happen: traffic
        case 'trafik':
            nextPage = undefined;

            if (getValueOrDefault(formConfig, formValues, 'trafficClaimReason').value === 'COLLISION') {
                nextPage = 'modpart';
            } else {
                nextPage = 'oplysninger-om-skaden';
            }

            break;
        case 'modpart':
            nextPage = 'oplysninger-om-skaden';

            if (getValueOrDefault(formConfig, formValues, 'counterpartInfoAvailaible').value === 'yes') {
                nextPage = 'oplysninger-om-modpart';
            }

            break;
        case 'oplysninger-om-modpart':
            nextPage = 'oplysninger-om-skaden';
            break;

        case 'politi':
            nextPage = 'paavirkning';
            break;

        case 'paavirkning':
            nextPage = 'dokumentation';

            if (getValueOrDefault(formConfig, formValues, 'alcohol').value === 'YES') {
                nextPage = 'hvilken-paavirkning';
            }

            break;
        case 'hvilken-paavirkning':
            nextPage = 'dokumentation';
            break;

        // =============================================================
        // Step 3: Documentation
        // =============================================================
        // page 17
        case 'dokumentation':
            nextPage = 'sygeforsikring';
            break;

        // =============================================================
        // Step 4: About you
        // =============================================================
        case 'sygeforsikring':
            nextPage = 'anden-ulykkesforsikring';
            break;
        case 'anden-ulykkesforsikring':
            nextPage = 'anden-forsikring';

            if (getValueOrDefault(formConfig, formValues, 'hasOtherHealthInsurance').value === 'yes') {
                nextPage = 'om-forsikringsselskabet';
            }

            break;
        case 'om-forsikringsselskabet':
            nextPage = 'anden-forsikring';
            break;
        case 'anden-forsikring':
            nextPage = 'om-dig';

            if (getValueOrDefault(formConfig, formValues, 'hasOtherInsuranceWithSimilarCoverage').value === 'yes') {
                nextPage = 'hvilket-selskab';
            }

            break;
        case 'hvilket-selskab':
            nextPage = 'andre-oplysninger';

            const otherInsuranceProvider = getValueOrDefault(formConfig, formValues, 'otherInsuranceProvider').value;
            if (otherInsuranceProvider === 'insuranceCompany') {
                nextPage = 'om-forsikringsselskabet-1';
            } else if (otherInsuranceProvider === 'bank') {
                nextPage = 'om-banken';
            }

            break;
        case 'om-forsikringsselskabet-1':
            nextPage = 'om-dig';
            break;
        case 'om-banken':
            nextPage = 'om-dig';
            break;
        case 'andre-oplysninger':
            nextPage = 'om-dig';
            break;

        case 'om-dig':
            nextPage = 'resume';
            break;
        // =============================================================
        // Step 5: Summery
        // =============================================================
        case 'resume':
            nextPage = undefined;
            break;
        default:
            console.log('# curPageId=', curPageId);
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};

const getNextPageBasedOnClaimActivity = (claimActivity: string) => {
    switch (claimActivity) {
        case 'TRAFFIC':
            return 'trafik';
        default:
            return 'oplysninger-om-skaden';
    }
};
